import React, { useState, useEffect } from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';
import Swal from 'sweetalert2';

import { Modal, Row, Col } from 'react-bootstrap';

export default function ViewCoinModal(props) {
  const { data, ...rest } = props;

  const coinInfo = data?.coinInfo;
  const symbol = data?.currency?.symbol;

  // Filter out tubes with tubeValue > 0 for display
  const activeTubes = coinInfo?.filter((tube) => tube.tubeValue > 0) || [];

  // Calculate total sum
  const totalSum = activeTubes.reduce((sum, tube) => {
    return sum + tube.tubeValue * tube.coinCount;
  }, 0);

  return (
    <Modal className="modal-w" {...rest} centered size="">
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Coin Information(
          {<span>Currency:{data?.currency?.code}</span>})
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-body">
        <div
          className="d-flex flex-column"
          style={{
            fontSize: '25px',
          }}
        >
          {activeTubes.length > 0 ? (
            <>
              {activeTubes.map((tube, i) => {
                return (
                  <div
                    className="d-flex align-items-center mb-5"
                    key={i}
                    style={{
                      fontSize: '18px',
                    }}
                  >
                    <div style={{ width: '50%' }}>
                      Value:{symbol}
                      {tube.tubeValue.toFixed(2)}
                    </div>
                    <div style={{ width: '50%' }}>Count:{tube.coinCount}</div>
                  </div>
                );
              })}
              <div
                className="d-flex align-items-center mt-3 pt-3"
                style={{
                  fontSize: '20px',
                  borderTop: '2px solid #ccc',
                  fontWeight: 'bold',
                }}
              >
                <div style={{ width: '50%' }}>Total Sum:</div>
                <div style={{ width: '50%' }}>
                  {symbol}
                  {totalSum.toFixed(2)}
                </div>
              </div>
            </>
          ) : (
            <div style={{ padding: '20px', textAlign: 'center' }}>
              <span>No coin information available</span>
            </div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
}
